export function useMainDomainLink() {
  const { SELF_URL } = useRuntimeConfig().public

  /**
   * Validate if the given link is from the main or subdomain of current SELF_URL
   */
  const validate = (link: string) => {
    if (link.startsWith('mailto:') || link.startsWith('tel:')) {
      return false
    }

    // absolute link
    if (link.startsWith('http')) {
      const linkMainDomain = new URL(link, link).hostname.split('.').slice(-2).join('.')
      const myMainDomain = new URL(SELF_URL, SELF_URL).hostname.split('.').slice(-2).join('.')
      const allowedDomains = [
        'autobid.de', // for more details: https://op.amab.dev/projects/frontend/work_packages/4502/activity#comment-42167
        'car-auctions.de',
        myMainDomain,
      ]
      return allowedDomains.includes(linkMainDomain)
    }

    // relative link
    return true
  }

  return {
    validate,
  }
}
